import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import { MyProvider } from "./State/ProviderData";
// CSS
// bootstrap.min.css retiré : main.scss compile déjà Bootstrap depuis
// les sources Sass avec les couleurs personnalisées ($primary, $warning,
// $success). Garder les deux en même temps recréait le bug historique
// du double-Bootstrap (voir commentaire en tête de main.scss).
import 'bootstrap/dist/js/bootstrap.bundle';
// import 'bootstrap/dist/css/bootstrap.min.css';
import "./styles/main.scss";
ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <MyProvider>
        <App />
      </MyProvider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);